import React, { FC } from "react";

// UI
import { Icon } from "../Icon/Icon";
import { CircleInfo } from "../Icons/CircleInfo";

// chakra UI
import { Tooltip as TooltipChakra } from "@chakra-ui/tooltip";
import { Tag } from "@chakra-ui/tag";
import { forwardRef } from "@chakra-ui/system";
import { BoxProps } from "@chakra-ui/react";

interface Props extends BoxProps {
  text: string;
  size?: number | string;
  bold?: boolean;
}

export const InfoTooltip: FC<Props> = ({
  size = "1rem",
  bold,
  text,
  ...rest
}) => {
  return (
    <TooltipChakra
      hasArrow
      label={text}
      placement="top"
      borderRadius={5}
      py={2}
      px={4}
      bgColor="gray.800"
    >
      <IconWrapper {...rest}>
        <Icon
          as={CircleInfo}
          height={size}
          width={size}
          color={bold ? "gray.800" : undefined}
        />
      </IconWrapper>
    </TooltipChakra>
  );
};

const IconWrapper = forwardRef(({ children, ...rest }, ref) => (
  <Tag minW={0} minH={0} p={0} ref={ref} {...rest}>
    {children}
  </Tag>
));
